import { BaseAuditingModel } from '../../bpg-common/models/base-auditing.model';

export class UserAttendanceModel extends BaseAuditingModel {

    public userAttendanceId: number;
    public eventId: number;
    public userId: number;
    public badgeId: string;
    public workdayId: string;

}
